// extracted by mini-css-extract-plugin
export default {"container":"InformationBanner__container--egZay","bannerImage":"InformationBanner__bannerImage--V9dqf","closeButton":"InformationBanner__closeButton--AFwWq"};